import { SectionIndexItem } from '../components/SectionIndexAutocomplete';

function makeItems(
  tabKey: string,
  tabLabel: string,
  sectionLabel: string,
  sectionId: string,
  labels: string[]
): SectionIndexItem[] {
  return labels.map((label) => ({
    label,
    sectionLabel,
    sectionId,
    tabKey,
    tabLabel,
  }));
}

export const houseSectionIndex: SectionIndexItem[] = [
  // region — Características e Região
  ...makeItems(
    'region',
    'Características e Região',
    'Usos Predominantes',
    'region-usos-predominantes',
    ['Usos Predominantes']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Infraestrutura Urbana',
    'region-infraestrutura-urbana',
    ['Infraestrutura Urbana']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Serviços Públicos e Comunitários',
    'region-servicos-publicos',
    ['Serviços Públicos e Comunitários']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Padrão das Edificações na Região',
    'region-padrao-edificacoes',
    ['Padrão das Edificações na Região']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Influências',
    'region-influencias',
    ['Influências', 'Valorizantes', 'Desvalorizantes']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Outras características',
    'region-outras-caracteristicas',
    [
      'Outras características',
      'Via de Acesso',
      'Descreva a Via de Acesso',
      'Região',
    ]
  ),

  // evaluating_unit — Unidade Avaliando
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Vistoria',
    'evaluating-unit-vistoria',
    ['Vistoria', 'Data da Vistoria']
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Características Gerais',
    'evaluating-unit-caracteristicas-gerais',
    [
      'Estado de Conservação',
      'Padrão de Acabamento',
      'Paredes Externas',
      'Idade Estimada',
      'Destinação',
      'Ocupação',
    ]
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Posição e Inserção',
    'evaluating-unit-posicao-insercao',
    ['Orientação Solar', 'Vista', 'Implantação/Inserção', 'Locação do Terreno']
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Vagas de Estacionamento',
    'evaluating-unit-vagas-estacionamento',
    ['Total de Vagas Cobertas', 'Total de Vagas Descobertas', 'Total de Vagas']
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Pavimentos',
    'evaluating-unit-pavimentos',
    [
      'Qtd de Pavimentos Unidade',
      'N° Pavimentos Subsolos',
      'N° Pavimentos Térreos',
      'N° Pavimentos Mezaninos',
      'N° Pavimentos Sobrelajes',
      'N° Pavimentos Coberturas',
      'N° Pavimentos Outros',
    ]
  ),

  // frames_and_facades — Esquadrias e Fachadas
  ...makeItems(
    'frames_and_facades',
    'Esquadrias e Fachadas',
    'Fachada Principal',
    'frames-fachada-principal',
    ['Esquadrias', 'Revestimento']
  ),
  ...makeItems(
    'frames_and_facades',
    'Esquadrias e Fachadas',
    'Demais Fachadas',
    'frames-demais-fachadas',
    ['Esquadrias', 'Revestimento']
  ),
  ...makeItems(
    'frames_and_facades',
    'Esquadrias e Fachadas',
    'Teto',
    'frames-teto',
    ['Materiais']
  ),
  ...makeItems(
    'frames_and_facades',
    'Esquadrias e Fachadas',
    'Cobertura',
    'frames-cobertura',
    ['Materiais']
  ),

  // wet_and_dry_areas — Áreas Molhadas e Secas
  ...makeItems(
    'wet_and_dry_areas',
    'Áreas Molhadas e Secas',
    'Áreas Molhadas',
    'wet-dry-areas-molhadas',
    ['Pisos', 'Paredes']
  ),
  ...makeItems(
    'wet_and_dry_areas',
    'Áreas Molhadas e Secas',
    'Áreas Secas',
    'wet-dry-areas-secas',
    ['Pisos']
  ),

  // construction_areas — Áreas de Construção
  ...makeItems(
    'construction_areas',
    'Áreas de Construção',
    'Áreas de Construção',
    'construction-areas-construcao',
    [
      'Áreas de Construção',
      'Privativa da Unidade',
      'Privativa Descontínua',
      'Áreas Comuns',
      'Total Averbada',
      'Total Não Averbada',
    ]
  ),
  ...makeItems(
    'construction_areas',
    'Áreas de Construção',
    'Privativa Descoberta',
    'construction-privativa-descoberta',
    ['Área']
  ),
  ...makeItems(
    'construction_areas',
    'Áreas de Construção',
    'Divisão Interna',
    'construction-divisao-interna',
    [
      'Sala(s)',
      'Hall(s)/Circulação(ões)',
      'Sacada(s)/Varanda(s)',
      'Terraço(s)',
      'Mezanino(s)',
      'Escritório/Gabinete',
      'Quarto(s)',
      'Quarto(s) de Empregada',
      'Closet(s)',
      'Cozinha(s)',
      'Cozinha Americana',
      'Copa(s)',
      'Copa/Cozinha Conjugadas',
      'Cozinha/Área de Serviço Conjugadas',
      'Área(s) de Serviço',
      'Área(s) de Serviço Descobertas',
      'Despensa(s)/Depósito(s)',
      'Banheiro(s) Sociai(s)',
      'Banheiro(s) Privativo(s)',
      'Banheiro(s) de Serviço',
      'Banheiro Privativo de Empregada',
      'Lavabo(s)',
    ]
  ),

  // land_and_fencing — Terreno e Cercamento
  ...makeItems(
    'land_and_fencing',
    'Terreno e Cercamento',
    'Lote da unidade',
    'land-lote-unidade',
    ['Posição', 'Cota/Greide', 'Formato Aproximado', 'Inclinação']
  ),
  ...makeItems(
    'land_and_fencing',
    'Terreno e Cercamento',
    'Tipo de cercamento',
    'land-tipo-cercamento',
    ['Cercamento', 'Frente', 'Lateral / Fundo', 'Vocação Principal']
  ),
  ...makeItems(
    'land_and_fencing',
    'Terreno e Cercamento',
    'Dados Físicos',
    'land-dados-fisicos',
    ['Área (m²)', 'Testada', 'Profundidade equivalente (m)', 'Lados']
  ),

  // enterprise — Empreendimento
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Dados Gerais',
    'enterprise-dados-gerais',
    [
      'Dados Gerais',
      'Padrão do Empreendimento',
      'Estado de Conservação',
      'Controle de Acesso',
      'N° de Prédios',
      'N° Total de Unidades',
      'N° de Unidade de Tipologia',
      'Fração Ideal',
    ]
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Terreno',
    'enterprise-terreno',
    [
      'Terreno',
      'Posição',
      'Cota/Greide',
      'Área (m²)',
      'Testada',
      'Profundidade equivalente (m)',
      'Cercamento',
      'Tipo Cercamento Frente',
      'Tipo Cercamento Lateral/Fundos',
    ]
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Usos e Infraestrutura',
    'enterprise-usos-infraestrutura',
    ['Usos e Infraestrutura', 'Ocupação do Terreno', 'Infraestrutura']
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Equipamentos',
    'enterprise-equipamentos',
    ['Equipamentos', 'N° Armários Embutidos', 'N° Salas de Lazer']
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Dados Administrativos',
    'enterprise-dados-administrativos',
    [
      'Dados Administrativos',
      'Taxa de Condomínio',
      'Administradora do Condomínio',
      'Telefone Administradora',
      'Email Administradora',
    ]
  ),
];
